import type { Dictionary } from '../../utils';
import { TranslationKeys } from '../../translations';

export enum FileType {
  Unknown = 'unknown',
  Excel = 'excel',
  Csv = 'csv',
  Xml = 'xml',
  PDF = 'pdf',
}

// Translation for the display name of each file type, used to build the dynamic "you can upload X, Y or Z files" message.
export const FileTypeToNameMessageId: Dictionary<string> = {
  [FileType.Excel]: TranslationKeys.upload_fileType_excel,
  [FileType.Csv]: TranslationKeys.upload_fileType_csv,
  [FileType.Xml]: TranslationKeys.upload_fileType_xml,
  [FileType.PDF]: TranslationKeys.upload_fileType_pdf,
};

export const FilesTypesToMime: Dictionary<string[]> = {
  excel: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  csv: ['text/csv'],
  xml: ['application/xml', 'text/xml'],
  pdf: ['application/pdf'],
};

export const ExtensionToFileType: Dictionary<FileType> = {
  xlsx: FileType.Excel,
  xls: FileType.Excel,
  csv: FileType.Csv,
  xml: FileType.Xml,
};

export const MimeToFileType = Object.keys(FilesTypesToMime).reduce((map: Dictionary<string>, type: string) => {
  const mimes = FilesTypesToMime[type];
  mimes.forEach(mime => {
    map[mime] = type;
  });
  return map;
}, {});
